/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-01-08 11:25:54
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:30:16
 * @FilePath: \h5-lcjc-formula\src\utils\category\Hema.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 血液病学 */

/** 对应的标题 */
const categoryMap = {
  AcuteMyeloidLeukemia: '急性髓系白血病危险度分级',
  ChronicLymphocyticLeukemia_Binet: '慢性淋巴细胞白血病（CLL）Binet分期系统',
  ChronicLymphocyticLeukemia_RAI: '慢性淋巴细胞白血病（CLL）RAI分期系统',
  TransferrinSaturation: '转铁蛋白饱和度',
  HITFourTsScore: '肝素诱导血小板减少症的4Ts诊断',
  APCCI: '校正的血小板计数增加值（CCI）',
  Acute_myeloid_leukaemia: '急性髓系白血病的危险度分级',
  Erythropoietin: '促红细胞生成素',
  Activated_Partial_Thromboplastin_Time: '活化部分凝血活酶时间（APTT）',
  Mean_Corpuscular_Volume: '平均红细胞体积（MCV）',
  Mean_Corpuscular_Hemoglobin: '平均红细胞血红蛋白含量（MCH）',
  Mean_Corpuscular_Hemoglobin_Concentration: '平均红细胞血红蛋白浓度（MCHC）',
  Mean_Platelet_Volume: '平均血小板体积（MPV）',
  Haptoglobin: '结合珠蛋白',
  Arginine: '精氨酸（Arg）',
  Soluble_Transferrin_Receptor: '可溶性转铁蛋白受体（sTfR）',
  TP: '总蛋白',
  HBG: '血红蛋白',
  Hemoglobin_subunit: '血红蛋白单体（亚基）',
  Hemoglobin_tetramer: '血红蛋白四聚体',
  Thrombin_Time: '凝血酶时间（TT）',
  Prothrombin_Time: '凝血酶原时间（PT）',
  Red_Cell_Distribution_Width_Standard_Deviation: '红细胞分布宽度标准差（RDW-SD）',
  Red_Cell_Distribution_Width: '红细胞分布宽度变异系数（RDW-CV）',
  Isopropanol: '异丙醇',
  Phylloquinone: '维生素K（叶绿醌）',
  Magnesium: '镁'
}
/** 对应的描述 */
const categoryDescMap = {
  AcuteMyeloidLeukemia: '急性髓系白血病风险分层',
  ChronicLymphocyticLeukemia_Binet: '慢性淋巴细胞白血病常用分期系统之一',
  ChronicLymphocyticLeukemia_RAI: '慢性淋巴细胞白血病常用分期系统之一',
  TransferrinSaturation: '识别铁缺乏',
  HITFourTsScore: 'HIT 4Ts score',
  Acute_myeloid_leukaemia: '2017年欧洲白血病网络（ELN）急性髓系白血病危险度分层体系'
}

export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Hema.js